import { parseISO } from 'date-fns';

function get4DigitYearString(year) {
  return year.toString().padStart(4, "0");
}
function parse4DigitYearStringToStartOfYearDate(fourDigitYearString) {
  return parseISO(`${fourDigitYearString}-01-01`);
}
function getStartOfYearDateFromYear(year) {
  return parse4DigitYearStringToStartOfYearDate(get4DigitYearString(year));
}

export { getStartOfYearDateFromYear };
//# sourceMappingURL=getStartOfYearDateFromYear.mjs.map
